import React from 'react';

const FetchContext = React.createContext();
FetchContext.displayName = 'FetchContext';

export default FetchContext;
